import {
  API_ENDPOINT_ADDAUCTION_ITEM,
  API_ENDPOINT_ADDAUCTION_OPEN_ITEM,
  API_ENDPOINT_AUCTION_CLOSE,
  API_ENDPOINT_GETAUCTION_ITEMS,
  API_ENDPOINT_GETAUCTION_OPEN_ITEMS,
} from '../Constants';
import BaseMarketplaceService from './BaseMarketplaceService';

export default class AuctionsService extends BaseMarketplaceService {
  async getAuctions() {
    const headers = await this.getAuthHeaders();
    const response = await fetch(API_ENDPOINT_GETAUCTION_ITEMS, { method: 'GET', headers });
    if (!response.ok) throw new Error(await response.text());
    return response.json();
  }

  async getOpenAuctions() {
    const headers = await this.getAuthHeaders();
    const response = await fetch(API_ENDPOINT_GETAUCTION_OPEN_ITEMS, { method: 'GET', headers });
    if (!response.ok) throw new Error(await response.text());
    return response.json();
  }

  async createAuction(payload) {
    const headers = await this.getAuthHeaders();
    const response = await fetch(API_ENDPOINT_ADDAUCTION_ITEM, {
      method: 'POST',
      headers,
      body: JSON.stringify(payload || {}),
    });
    if (!response.ok) throw new Error(await response.text());
    return response.json();
  }

  async openAuction(payload) {
    const headers = await this.getAuthHeaders();
    const response = await fetch(API_ENDPOINT_ADDAUCTION_OPEN_ITEM, {
      method: 'POST',
      headers,
      body: JSON.stringify(payload || {}),
    });
    if (!response.ok) throw new Error(await response.text());
    return response.json();
  }

  async closeAuction(payload) {
    const headers = await this.getAuthHeaders();
    const response = await fetch(API_ENDPOINT_AUCTION_CLOSE, {
      method: 'POST',
      headers,
      body: JSON.stringify(payload || {}),
    });
    if (!response.ok) throw new Error(await response.text());
    return response.json();
  }
}

